import React, { Component } from 'react';
import { NavLink, withRouter } from 'react-router-dom';

import IntlMessages from 'util/IntlMessages';
import CustomScrollbars from 'util/CustomScrollbars';

class SidenavContentAdmin extends Component {
	componentDidMount() {
		const { history } = this.props;
		const that = this;
		const pathname = `#${history.location.pathname}`; // get current path

		const subMenuLi = document.querySelectorAll('.sub-menu > li');
		for (let i = 0; i < subMenuLi.length; i++) {
			subMenuLi[i].onclick = function(event) {
				event.stopPropagation();
			};
		}

		const menuLi = document.getElementsByClassName('menu');
		for (let i = 0; i < menuLi.length; i++) {
			menuLi[i].onclick = function(event) {
				for (let j = 0; j < menuLi.length; j++) {
					const parentLi = that.closest(this, 'li');
					if (menuLi[j] !== this && (parentLi === null || !parentLi.classList.contains('open'))) {
						menuLi[j].classList.remove('open');
					}
				}
				this.classList.toggle('open');
				event.stopPropagation();
			};
		}

		const activeLi = document.querySelector('a[href="' + pathname + '"]'); // select current a element
		try {
			const activeNav = this.closest(activeLi, 'ul'); // select closest ul
			if (activeNav.classList.contains('sub-menu')) {
				this.closest(activeNav, 'li').classList.add('open');
			} else {
				this.closest(activeLi, 'li').classList.add('open');
			}
		} catch (error) {}
	}

	closest(el, selector) {
		try {
			let matchesFn;
			// find vendor prefix
			['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'].some(function(fn) {
				if (typeof document.body[fn] == 'function') {
					matchesFn = fn;
					return true;
				}
				return false;
			});

			let parent;

			// traverse parents
			while (el) {
				parent = el.parentElement;
				if (parent && parent[matchesFn](selector)) {
					return parent;
				}
				el = parent;
			}
		} catch (e) {}

		return null;
	}

	render() {
		return (
			<CustomScrollbars className="scrollbar" style={{ height: 'calc(100vh - 70px)' }}>
				<ul className="nav-menu">
					<li className="nav-header">
						<IntlMessages id="navigation.main.title" />
					</li>
					<li className="menu no-arrow">
						<NavLink to="/app/admin-dashboard">
							<i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
							<span className="nav-text">
								<IntlMessages id="dashboard.title" />{' '}
							</span>
						</NavLink>
					</li>
					<li className="menu no-arrow">
						<NavLink to="/app/dashboard">
							<i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
							<span className="nav-text">
								<IntlMessages id="dashboard.title" />{' '}
							</span>
						</NavLink>
					</li>
					<li className="menu no-arrow">
						<NavLink to="/app/analysis">
							<i className="zmdi zmdi-chart zmdi-hc-fw" />
							<span className="nav-text">
								<IntlMessages id="analysis.title" />{' '}
							</span>
						</NavLink>
					</li>
					<li className="nav-header">
						<IntlMessages id="navigation.meldooplus.title" />
					</li>
					<li className="menu no-arrow">
						<NavLink to="/app/admin-report">
							<i className="zmdi zmdi-alert-triangle zmdi-hc-fw" />
							<span className="nav-text">
								<IntlMessages id="adminReports.title" />{' '}
							</span>
						</NavLink>
						<NavLink to="/app/admin-report-map">
							<i className="zmdi zmdi-google-maps zmdi-hc-fw" />
							<span className="nav-text">
								<IntlMessages id="adminReportMap.title" />{' '}
							</span>
						</NavLink>
						<NavLink to="/app/admin-organisations">
							<i className="zmdi zmdi-balance zmdi-hc-fw" />
							<span className="nav-text">
								<IntlMessages id="adminOrganisations.title" />{' '}
							</span>
						</NavLink>
						<NavLink to="/app/admin-responsibilities">
							<i className="zmdi zmdi-grid zmdi-hc-fw" />
							<span className="nav-text">
								<IntlMessages id="adminResponsibilities.title" />{' '}
							</span>
						</NavLink>
						<NavLink to="/app/admin-system-roles-settings">
							<i className="zmdi zmdi-account-box-mail zmdi-hc-fw" />
							<span className="nav-text">
								<IntlMessages id="adminSystemRolesSettings.title" />{' '}
							</span>
						</NavLink>
					</li>
					<li className="nav-header">
						<IntlMessages id="navigation.meldoo.title" />
					</li>
					<li className="menu no-arrow">
						<NavLink to="/app/admin-feedback">
							<i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
							<span className="nav-text">
								<IntlMessages id="feedback.title" />{' '}
							</span>
						</NavLink>
					</li>
					<li className="nav-header">
						<IntlMessages id="navigation.reports.title" />
					</li>
					<li className="menu no-arrow">
						<NavLink to="/app/report-table">
							<i className="zmdi zmdi-view-list zmdi-hc-fw" />
							<span className="nav-text">
								<IntlMessages id="reportTable.title" />{' '}
							</span>
						</NavLink>
						<NavLink to="/app/report-map">
							<i className="zmdi zmdi-google-maps zmdi-hc-fw" />
							<span className="nav-text">
								<IntlMessages id="reportMap.title" />{' '}
							</span>
						</NavLink>
						<NavLink to="/app/report-archive">
							<i className="zmdi zmdi-archive zmdi-hc-fw" />
							<span className="nav-text">
								<IntlMessages id="archive.title" />{' '}
							</span>
						</NavLink>
					</li>
					<li className="nav-header">
						<IntlMessages id="navigation.settings.title" />
					</li>
					<li className="menu no-arrow">
						<NavLink to="/app/user-settings">
							<i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
							<span className="nav-text">
								<IntlMessages id="userSettings.title" />{' '}
							</span>
						</NavLink>
						<NavLink to="/app/group-settings">
							<i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
							<span className="nav-text">
								<IntlMessages id="groupSettings.title" />{' '}
							</span>
						</NavLink>
					</li>
					<li className="menu no-arrow">
						<NavLink to="/app/faq">
							<i className="zmdi zmdi-help zmdi-hc-fw" />
							<span className="nav-text">
								<IntlMessages id="faq.title" />{' '}
							</span>
						</NavLink>
					</li>
				</ul>
			</CustomScrollbars>
		);
	}
}

export default withRouter(SidenavContentAdmin);



// WEBPACK FOOTER //
// ./containers/SideNav/SidenavContentAdmin.js